<template>
  <div class="problemOfGoods">
    <div class="order">
      問題商品番号:
      <a target="_blank" :href="'  https://www.rakumart.com/OrderDetails?order_sn=' +
        detail.order_sn
        ">
        {{ detail.order_sn }}
      </a>
    </div>
    <div class="detail">
      <div class="flexs">問題詳細</div>
      <div class="flexs y_fan" v-if="detail.description_translate.length < 18">
        {{ detail.description_translate }}
      </div>

      <div class="flexs y_fan1" v-else>
        {{ detail.description_translate }}
      </div>
      <div class="flexs pic">
        <a :href="'https://www.rakumart.com/ProductDetails?fromPlatformt=' +
          detail.order_detail.from_platform +
          '&goods_id=' +
          detail.order_detail.goods_id
          " target="_blank">
          <img :src="detail.pic" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },

  data() {
    return {};
  },
  computed: {
    detail() {
      return JSON.parse(this.message.payload.description);
    },
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.problemOfGoods {
  padding: 5px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 300px;

  .order {
    margin-bottom: 3px;

    a {
      color: #408d7c;
      text-decoration: underline;
    }
  }

  .detail {
    display: flex;
    height: 40px;
    min-width: 230px;
    max-width: 400px;

    .flexs {
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .y_fan {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
    }

    .y_fan1 {
      flex: 2;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 13px;
    }

    .pic {
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>